import { FaDownload } from "react-icons/fa";
import calendarIcon from "../../../assets/images/calendar.svg";
import CompanySelector from "../../../components/common/CompanySelector";

export default function LeaveManagementHeader({
  companyList,
  selectedCompany,
  setSelectedCompany,
  onCalendarClick,
  onDownloadClick,
}) {
  return (
    <div className="flex items-center justify-between mt-7 mb-6">
      <h1 className="text-2xl font-medium text-medium-dark-gray">
        Leave Management
      </h1>

      <div className="flex items-center gap-8">
        <CompanySelector
          companyList={companyList}
          selectedCompany={selectedCompany}
          onCompanyChange={(company) => {
            if (!company) {
              setSelectedCompany(null);
              return;
            }

            setSelectedCompany({
              id: company.id,
              name: company.company_name,
            });
          }}
          selectClassName="!py-0.5 px-2 text-sm w-[200px]"
        />

        <div className="flex items-center gap-7">
          <img
            src={calendarIcon}
            alt="Calendar"
            onClick={onCalendarClick}
            className="cursor-pointer"
          />

          <FaDownload
            onClick={onDownloadClick}
            className="text-green-600 text-2xl cursor-pointer"
            title="Download Leave Details"
          />
        </div>
      </div>
    </div>
  );
}
